export default __webpack_public_path__ + "static/media/daily-icon.946b0710.svg";